export default "__VITE_ASSET__eVB8XM_o__"